import { EditorialStat } from '../types/editorial-stat.type';
import { EditorialValueCard } from '../types/editorial-value-card.type';
import { PUBLIC_EDITORIAL_APP_PATHS } from './public-editorial-paths.constants';

import guidingIllustration from '../../assets/img/val_conv_1.png';
import carbonIllustration from '../../assets/img/val_conv_2.png';
import sourcingIllustration from '../../assets/img/val_conv_3.png';
import wasteIllustration from '../../assets/img/val_conv_4.png';
import shareholdingIllustration from '../../assets/img/val_ouv_4.png';
import teamPhotograph from '../../assets/img/team.png';

// Contenu relevé sur la page legacy /valeurs (src/views/Front/NosValeurs/Valeurs.js). Le séparer
// du rendu permet de vérifier la fidélité au legacy sans monter la page.
export const OUR_VALUES_HERO = {
  title: 'Nos valeurs',
  subtitle: 'Une entreprise collaborative',
  lead: 'Ensemble nous partageons des valeurs et nous portons un projet commun.',
};

export const OUR_VALUES_CARDS: EditorialValueCard[] = [
  {
    illustration: guidingIllustration,
    illustrationAlt: 'Un maraîcher portant une cagette de légumes',
    lead: 'Ce qui nous guide',
    points: [
      "Le respect de la terre, de l'eau et du vivant.",
      "Le maintien d'un lien agricole et d'une agriculture durable.",
      "L'héritage que nous laissons aux générations futures.",
    ],
  },
  {
    illustration: carbonIllustration,
    illustrationAlt: 'Un livreur à vélo',
    lead: 'Le CO2, on le réduit !',
    points: ['Livraison de Paris à vélo', 'Mutualisation des livraisons avec les commandes groupées'],
  },
  {
    illustration: sourcingIllustration,
    illustrationAlt: 'Une sélection de fruits et légumes',
    lead: 'Aucun compromis sur le choix de nos produits',
    points: ['Du bio, rien que du bio, et un maximum de local !'],
  },
  {
    illustration: wasteIllustration,
    illustrationAlt: 'Un panier et ses emballages réutilisables',
    lead: "Et oui, un panier bio, c'est zéro déchet",
    points: ['100% de nos emballages sont réutilisables ou renouvelables !'],
    ctaLabel: 'Voir',
    ctaPath: PUBLIC_EDITORIAL_APP_PATHS.ZERO_WASTE,
  },
];

export const OUR_VALUES_COMMITMENTS = {
  title: 'Bio Culture, une entreprise collaborative et humaine',
  photograph: teamPhotograph,
  photographAlt: "L'équipe de Bio Culture",
  points: [
    'Des salariés engagés et fiers de participer à un objectif commun',
    'Une confiance réciproque entre tous les acteurs de la société : clients, salariés, producteurs, fournisseurs',
    'Une parité hommes / femmes',
    "Un ratio de moins de 1,3 entre le salaire le plus haut et le plus bas, parce que chaque membre de notre équipe joue un rôle clé et participe à la continuité de l'entreprise",
    "2 membres d'un ESAT qui viennent quotidiennement renforcer nos équipes, participer à un équilibre social",
  ],
};

export const OUR_VALUES_SHAREHOLDING = {
  title: 'Une entreprise ouverte',
  illustration: shareholdingIllustration,
  illustrationAlt: 'Répartition des dividendes',
  note: 'Un reversement de 20% des dividendes aux salariés et de 40% en réinvestissements dans des projets portant nos valeurs.',
  stats: [
    {
      value: '70%',
      description: "d'actionnaires clients qui donnent de leur temps pour co-construire un projet commun",
    },
    {
      value: '20%',
      description: "d'actionnaires salariés ou anciens salariés qui ont décidé d'aller plus loin dans leur engagement",
    },
    {
      value: '10%',
      description: "d'actionnaires entrepreneurs, impliqués dans une cause écologique",
    },
  ] as EditorialStat[],
};

export const OUR_VALUES_VIDEO = {
  title: 'Découvrez Bio Culture en images',
  embedUrl: 'https://www.youtube.com/embed/9MI4OdEBhnU',
};
